//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'select-room-modal',
    props: {
        onSelected: Function,
        projectId: {
            type: Number
        }
    },
    data() {
        const vm = this;
        return {
            loading: false,
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            searchInput: {
                projectId: 0
            },
            list: [],
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '城市名称',
                    key: 'cityName'
                },
                {
                    title: '项目名称',
                    key: 'projectName'
                },
                {
                    title: '分期名称',
                    key: 'projectStages'
                },
                {
                    title: '楼栋号',
                    key: 'roomStructureName'
                },
                {
                    title: '单元号',
                    key: 'chamberName'
                },
                {
                    title: '楼层',
                    key: 'storeyName'
                },
                {
                    title: '房号',
                    key: 'roomNumber'
                },
                {
                    title: '操作',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        var edit = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.onRowClick(params.row);
                                }
                            }
                        }, '选择');
                        actions.push(edit);
                        return h('div', actions);
                    }
                }
            ],
            projects: [],
            cityList: []
        };
    },
    computed: {},
    methods: {
        pageChange(page) {
            // this.$store.commit('project/setCurrentPage', page);
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            // this.$store.commit('project/setPageSize', pagesize);
            this.pageSize = pagesize;
            this.getPage();
        },
        async getPage() {
            let page = {
                projectName: this.searchInput.projectName,
                cityName: this.searchInput.cityName,
                projectStages: this.searchInput.projectStages,
                roomStructureName: this.searchInput.roomStructureName,
                projectId: this.searchInput.projectId,
                maxResultCount: this.pageSize,
                skipCount: (this.currentPage - 1) * this.pageSize
            };
            // this.searchInput.maxResultCount = this.pageSize;
            // this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            await abp.ajax.post('/api/services/app/Project/SearchRooms', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });

        },
        onRowClick(row, index) {
            const vm = this;
            if (vm.onSelected !== undefined) {
                vm.onSelected(row);
            }
        },
        getProjects(cityId) {
            this.$store.dispatch({
                type: 'project/getProjects',
                data: { cityId: cityId }
            }).then(() => {
                this.projects = this.$store.state.project.projects;
            });
        },
        citySelectChange(val) {
            if (parseInt(val) > 0) {
                this.getProjects(parseInt(val));
            } else {
                this.projects = [];
            }
        },
        getCities() {
            this.$store.dispatch({
                type: 'city/getCityList'
            }).then(() => {
                this.cityList = this.$store.state.city.cityList;
            });
        }
    },
    created() {
        this.getPage();
        // this.getProjects();
        this.getCities();
    }
};
